import { useMemo } from "react"
import { useOrganizationPermissions } from "../useOrganizationPermissions"
import type {
  UseAuthorizedContentParams,
  UseAuthorizedContentReturn,
} from "./useAuthorizedContent.types"

/**
 * Hook to check if organization user has permission for specific content
 * @param params - Resource and action to check
 * @returns Authorization status and loading state
 */
export const useAuthorizedContent = ({
  resource,
  action,
}: UseAuthorizedContentParams): UseAuthorizedContentReturn => {
  const { hasPermission, isLoading, error } = useOrganizationPermissions()

  const isAuthorized = useMemo(() => {
    return hasPermission(resource, action)
  }, [hasPermission, resource, action])

  return {
    isAuthorized,
    isLoading,
    error,
  }
}
